import { render, staticRenderFns } from "./VectorOnDemandInfo.vue?vue&type=template&id=27e7ff72"
import script from "./VectorOnDemandInfo.vue?vue&type=script&lang=js"
export * from "./VectorOnDemandInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports